import React, { FC } from 'react';

import { Container, ContainerProps } from '@lglp/components';

import { getDomain } from '../../helpers/root';
import { getUrlFromDocument } from '../../helpers/routes/mapping';
import { Link, LinkDocument, LinkMedia, LinkType, LinkWeb } from '../../types';
import styles from './LinkedComponent.module.scss';

export const LinkedComponent: FC<LinkedComponentProps> = ({
  disabled,
  link,
  className,
  children,
  ...rest
}) => {
  if (link && !disabled) {
    if (
      link.linkType === LinkType.LINK_TYPE_WEB ||
      link.linkType === LinkType.LINK_TYPE_MEDIA
    ) {
      const url = (link as LinkWeb | LinkMedia).url;
      const isInternal = url.startsWith(getDomain()) || url.startsWith('/');

      return (
        <Container
          as="a"
          href={url}
          className={[
            styles.link,
            link.linkType || 'link-other',
            'link',
            className,
          ]}
          rel={!isInternal ? 'noopener noreferrer' : undefined}
          target={isInternal ? '_self' : '_blank'}
          {...rest}
        >
          {children}
        </Container>
      );
    }

    if (link.linkType === LinkType.LINK_TYPE_DOC) {
      return (
        <Container
          as="a"
          href={getUrlFromDocument(link)}
          hrefLang={(link as LinkDocument).lang}
          className={[
            styles.link,
            link.linkType || 'link-other',
            'link',
            className,
          ]}
          {...rest}
        >
          {children}
        </Container>
      );
    }
  }

  return (
    <Container
      className={[styles.link, disabled && styles.disabled, className]}
      {...rest}
    >
      {children}
    </Container>
  );
};

export type LinkedComponentProps = ContainerProps & {
  link?: Link;
  disabled?: boolean;
};
